module.exports = __webpack_public_path__ + "static/media/camel_w_700.d6635388.jpg";